export class Choice<T> {
  private title: string;
  private value: T;
  public action: (val: T) => void;

  constructor(title: string, value: T, action: (val: T) => void) {
    this.title = title;
    this.value = value;
    this.action = action;
  }

  public getTitle(): string {
    return this.title;
  }

  public getValue(): T {
    return this.value;
  }
}
